import React from "react";
import { Link } from "react-router-dom";
import { MapPin, Mail, Phone } from "lucide-react";

export default function Footer() {
  return (
    <footer className="mt-24 bg-risco-dark text-stone-300" data-testid="site-footer">
      <div className="container-x py-20 grid grid-cols-1 md:grid-cols-12 gap-10">
        <div className="md:col-span-5">
          <div className="flex items-center">
            <img src="/logo-risco-light.png" alt="Ri.Sco. s.r.l." style={{ height: '72px', width: 'auto' }} />
          </div>
          <p className="mt-6 text-sm text-stone-400 leading-relaxed max-w-md">
            Impresa edile a Napoli: ristrutturazioni, edificazioni e operazioni immobiliari con
            team interno completo. Dall'idea all'opera finita.
          </p>
          <div className="mt-8 flex items-center gap-3">
            <a href="mailto:info@riscocostruzioni.it" className="inline-flex items-center gap-2 px-4 py-2 rounded-md bg-risco-accent hover:bg-risco-accent-dark text-white text-sm font-semibold">
              <Mail className="w-4 h-4" /> Scrivici
            </a>
          </div>
        </div>

        <div className="md:col-span-2">
          <div className="text-[10px] font-semibold uppercase tracking-[0.22em] text-risco-accent mb-5">Servizi</div>
          <ul className="space-y-3 text-sm">
            <li><Link to="/ristrutturazioni" className="text-stone-300 hover:text-risco-bg transition-colors">Ristrutturazioni</Link></li>
            <li><Link to="/edificazioni" className="text-stone-300 hover:text-risco-bg transition-colors">Edificazioni</Link></li>
            <li><Link to="/operazioni-immobiliari" className="text-stone-300 hover:text-risco-bg transition-colors">Operazioni Immobiliari</Link></li>
            <li><Link to="/simulatore" className="text-stone-300 hover:text-risco-bg transition-colors">Preventivo Smart AI</Link></li>
          </ul>
        </div>

        <div className="md:col-span-2">
          <div className="text-[10px] font-semibold uppercase tracking-[0.22em] text-risco-accent mb-5">Azienda</div>
          <ul className="space-y-3 text-sm">
            <li><Link to="/team" className="text-stone-300 hover:text-risco-bg transition-colors">Il Team</Link></li>
            <li><Link to="/portfolio" className="text-stone-300 hover:text-risco-bg transition-colors">Portfolio</Link></li>
            <li><Link to="/contatti" className="text-stone-300 hover:text-risco-bg transition-colors">Contatti</Link></li>
            <li><Link to="/privacy" className="text-stone-300 hover:text-risco-bg transition-colors">Privacy</Link></li>
          </ul>
        </div>

        <div className="md:col-span-3">
          <div className="text-[10px] font-semibold uppercase tracking-[0.22em] text-risco-accent mb-5">Contatti</div>
          <ul className="space-y-3 text-sm text-stone-300">
            <li className="flex items-start gap-2"><MapPin className="w-4 h-4 mt-0.5 text-risco-accent shrink-0" /><span>Via Martiri di Pietrarsa 20<br/>80046 San Giorgio a Cremano (NA)</span></li>
            <li className="flex items-center gap-2"><Phone className="w-4 h-4 text-risco-accent shrink-0" /><a href="tel:+390810623700" data-testid="footer-phone-link" className="hover:text-risco-bg">081 062 3700</a></li>
            <li className="flex items-center gap-2"><Mail className="w-4 h-4 text-risco-accent shrink-0" /><a href="mailto:info@riscocostruzioni.it" className="hover:text-risco-bg">info@riscocostruzioni.it</a></li>
          </ul>
        </div>
      </div>

      <div className="border-t border-stone-800/60">
        <div className="container-x py-6 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3 text-xs text-stone-500">
          <div>© {new Date().getFullYear()} Ri.Sco. s.r.l. — P.IVA 09679001215 — San Giorgio a Cremano (NA)</div>
          <div className="flex gap-6">
            <Link to="/privacy" className="hover:text-risco-bg">Privacy Policy</Link>
            <Link to="/privacy" className="hover:text-risco-bg">Cookie Policy</Link>
            <Link to="/admin" className="hover:text-risco-bg">Area riservata</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
